import { render, staticRenderFns } from "./multi-store-icon.vue?vue&type=template&id=705bc11e&scoped=true"
import script from "./multi-store-icon.vue?vue&type=script&lang=js"
export * from "./multi-store-icon.vue?vue&type=script&lang=js"
import style0 from "./multi-store-icon.vue?vue&type=style&index=0&id=705bc11e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705bc11e",
  null
  
)

export default component.exports